class CartDrawer extends DrawerFixed {
  constructor() {
    super();

    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#cart-icon-bubble, .pp-cart-icon, [data-open-cart], .header__icon--cart, a[href$="/cart"]');
    if (!cartLinks.length) return;
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE' || event.key === 'Enter') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    try {
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      this.updateProductRecommendation();
    } catch (err) {
      console.warn('CartDrawer open pre-check error:', err);
    }
    super.open(triggeredBy);
  }

  close(evt) {
    try {
      const currentFooterAction = this.querySelector('cart-drawer-footer-action.open');
      if(currentFooterAction && typeof currentFooterAction.closeActionContent === 'function') {
        currentFooterAction.closeActionContent();
      }
    } catch (err) {
      console.warn('CartDrawer close action error:', err);
    }
    if(!this.classList.contains('busy') || !evt?.target?.closest('cart-drawer-footer-action')) {
      super.close(evt);
    }    
  }

  setSummaryAccessibility(cartDrawerNote) {
    if (!cartDrawerNote) return;
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details')?.hasAttribute('open'));
    });

    if (cartDrawerNote.parentElement && typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  renderContents(parsedState) {
    if (this.classList.contains('is-empty')) this.classList.remove('is-empty');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
    this.productId = parsedState ? parsedState.id : null;
    if (parsedState && typeof parsedState.item_count === 'number' && typeof window.updateAllCartCountBubbles === 'function') {
      window.updateAllCartCountBubbles(parsedState.item_count);
    }
    if (parsedState && parsedState.sections && typeof this.getSectionsToRender === 'function') {
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if(sectionElement && parsedState.sections[section.id]) {
          const content = typeof this.getSectionInnerHTML === 'function'
            ? this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
            : (typeof getInnerHtmlFromText === 'function' ? getInnerHtmlFromText(parsedState.sections[section.id], section.selector) : parsedState.sections[section.id]);
          if (content) sectionElement.innerHTML = content;
        }
      }));
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  updateProductRecommendation() {
    try {
      this.productRecommendation = this.querySelector('cart-product-recommendations');
      if(this.productRecommendation) {
        const cartItemsWrapper = this.querySelector('.cart-drawer__items');
        if (cartItemsWrapper) {
          cartItemsWrapper.classList.toggle('cart-drawer__items--large', cartItemsWrapper.querySelectorAll('.cart-item').length > 1);
        }
        if (typeof this.productRecommendation.update === 'function') {
          this.productRecommendation.update();
        }
      }
    } catch (err) {
      console.warn('CartDrawer updateProductRecommendation error:', err);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        section: 'CartDrawer',
        id: 'cart-drawer',
        selector: '.cart-drawer__items'
      },
      {
        section: 'CartDrawer',
        id: 'cart-drawer',
        selector: '.cart-drawer__footer--subtotal'
      },
      {
        section: 'cart-icon-bubble',
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  updateProductRecommendation() {
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    if(cartDrawerWrapper) {
      cartDrawerWrapper.updateProductRecommendation();
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerFooterAction extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.cart-drawer__footer__action-label');
    this.content = this.querySelector('.cart-drawer__footer__action-content');
    this.closeButton = this.content.querySelector('.cart-drawer__footer__action-close');
    
    this.openButton.addEventListener('click', this.onClickFooterAction.bind(this));
    this.closeButton.addEventListener('click', this.closeActionContent.bind(this));

    this.cartDrawer = this.closest('.drawer__inner');
  }

  onClickFooterAction(event) {
    const isOpen = this.classList.contains('open');
    isOpen ? this.closeActionContent(event) : this.openActionContent(); 
  }

  openActionContent() {
    this.style.setProperty('--drawer-bottom-position', `${Math.floor(this.cartDrawer.scrollTop)}px`);
    this.classList.add('open');
    this.content.classList.add('appear')
    setTimeout(() => {this.content.classList.add('animate')}, 1);
    setTimeout(() => {this.content.querySelector('textarea,select').focus();}, 300);
    this.closest('cart-drawer').classList.add('busy');
  }

  closeActionContent() {
    this.classList.remove('open');
    this.content.classList.remove('animate');
    setTimeout(() => {
      this.content.classList.remove('appear');
      const cartDrawer = this.closest('cart-drawer');
      cartDrawer.classList.remove('busy');
      trapFocus(cartDrawer, this.openButton);
    }, 300);
  }
}

customElements.define('cart-drawer-footer-action', CartDrawerFooterAction);

class CartDrawerNote extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('textarea');
    this.button = this.querySelector('.button');
    
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const body = JSON.stringify({ note: this.input.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      this.closest('cart-drawer-footer-action').closeActionContent();
    }, false);
  }
}

customElements.define('cart-drawer-note', CartDrawerNote);

// Global click delegation for all cart icons and triggers
document.addEventListener('click', (event) => {
  const cartTrigger = event.target.closest('#cart-icon-bubble, .pp-cart-icon, [data-open-cart], .header__icon--cart, a[href$="/cart"]');
  if (cartTrigger && !cartTrigger.closest('cart-drawer')) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open(cartTrigger);
      } else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden', 'open-drawer-fixed');
      }
    }
  }
});
